import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    emoji: string;
    labelInviteButton: string;
    labelInvite: (name?: string, resourceType?: string) => string | React.ReactNode;
    labelManage: string;
    labelMembers: (count: number) => string | React.ReactNode;
    ariaLabelManageMembers: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** And alt text for an image that displays an emoji */
            emoji: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessDialog.emoji?c=3blfr39u4hcib", defaultMessage: "Emoji" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the button that adds members to a resource in the member access dialog */
            labelInviteButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessDialog.labelInviteButton?c=295qccw425qqf", defaultMessage: "Add" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for header of one of the accordion dialog items that says to which resource to add members in the member access dialog */
            labelInvite: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (name?: string, resourceType?: string) => { if (resourceType === "FolderAsset") {
                        return __intl__.intl().formatMessage({ id: "MemberAccessDialog.labelInvite.0?c=1utjpc29m41bq", defaultMessage: "Add to Folder \"{name}\"" }, { name: name });
                    } return __intl__.intl().formatMessage({ id: "MemberAccessDialog.labelInvite.1?c=37rr75gfdsn05", defaultMessage: "Add to {name}" }, { name: name }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the accordion dialog item that manages members in the member access dialog */
            labelManage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessDialog.labelManage?c=3stoapfr4uswy", defaultMessage: "Manage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text for the header of one of the accordion dialog items that displays the number of members in the member access dialog */
            labelMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "MemberAccessDialog.labelMembers?c=kq3wy1t8ji8g", defaultMessage: "{count, plural, one {{count} Member} other {{count} Members}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label text for the accordion dialog item that manages members in the member access dialog */
            ariaLabelManageMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MemberAccessDialog.ariaLabelManageMembers?c=1p76ccvrrmahv", defaultMessage: "Manage these members" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
